import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { CITIES, IMAGES, BUSINESS } from "@/data/site";
import { usePageMeta, PageHero, SectionLabel, CTABanner } from "@/components/common";

export default function ServiceAreas() {
  usePageMeta("Service Areas", "A.D.N Stucco Inc serves Orlando, Kissimmee, St. Cloud, Winter Garden, Lake Nona, Clermont and communities across Central Florida.");
  return (
    <div data-testid="service-areas-page">
      <PageHero label="Where We Work" title="Serving all of Central Florida" subtitle="Local stucco expertise you can count on. Select your city to learn more about our services in your area." image={IMAGES.commercial} />

      <section className="py-24 bg-adn-white">
        <div className="max-w-7xl mx-auto px-6">
          <SectionLabel>Cities We Serve</SectionLabel>
          <h2 className="text-4xl font-heading font-extrabold mt-6 mb-12">Find your local stucco contractor</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {CITIES.map((c) => (
              <Link key={c.slug} to={`/service-areas/${c.slug}`} data-testid={`city-${c.slug}`} className="group flex items-center justify-between border border-zinc-200 bg-white p-6 hover:border-adn-red hover:-translate-y-0.5 transition-all duration-300">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-adn-redlight text-adn-red group-hover:bg-adn-red group-hover:text-white transition-colors"><MapPin size={20} /></div>
                  <div>
                    <div className="font-heading font-bold">{c.name}, FL</div>
                    <div className="text-sm text-zinc-500">Stucco Contractor</div>
                  </div>
                </div>
                <ArrowRight size={18} className="text-adn-red opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
              </Link>
            ))}
          </div>
          <div className="mt-16 border border-zinc-200 overflow-hidden">
            <iframe title="Service area map" src={BUSINESS.mapEmbed} width="100%" height="400" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
          </div>
        </div>
      </section>
      <CTABanner />
    </div>
  );
}
